exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".panel-group[data-v-5c95ae55],.panel[data-v-5c95ae55]{margin-bottom:0}h2 .fa[data-v-5c95ae55]{padding-right:12px;color:#337ab7}.cc-kombox-item[data-v-5c95ae55]{border-bottom:1px solid #d3d3d3;padding-top:5px;padding-bottom:5px}.cc-kombox-item[data-v-5c95ae55]:hover,.cc-memo-item[data-v-5c95ae55]:hover{background-color:#fcf8e3}.cc-kombox-list[data-v-5c95ae55],.cc-memo-list[data-v-5c95ae55]{height:100%;overflow:auto}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-5c95ae55&scoped=true!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/CompanyClient.vue
// module id = 207
// module chunks = 0